import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchSiteContent } from "../lib/api";

const PAGES = {
  shipping: { eyebrow: "Shipping", key: "shipping" },
  returns: { eyebrow: "Returns", key: "returns" },
  "size-guide": { eyebrow: "Size Guide", key: "size_guide" },
  "garment-care": { eyebrow: "Garment Care", key: "garment_care" },
};

export default function InfoPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const cfg = PAGES[slug] || PAGES.shipping;
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchSiteContent().then((sc) => setContent(sc?.legal?.[cfg.key] || null));
  }, [cfg.key]);

  if (!content) {
    return <div className="min-h-[60vh] flex items-center justify-center text-[#7A7A7A] text-sm">Loading…</div>;
  }

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid={`info-${slug}`}>
      <p className="eyebrow">{cfg.eyebrow}</p>
      <h1 className="font-serif-display text-5xl md:text-6xl mt-3 leading-[0.95]">{content.title}</h1>
      <p className="text-[#4A4A4A] mt-5 text-lg leading-relaxed">{content.subtitle}</p>
      <div className="border-t border-[#a89e80] mt-10 pt-10 space-y-6 text-[15px] leading-[1.75] text-[#3a3a3a] whitespace-pre-wrap">
        {content.body}
      </div>
      <div className="mt-14 flex flex-wrap gap-4 text-[11px] tracking-[0.22em] uppercase">
        <Link to="/shop" className="bg-[#1A1A1A] text-[#c3ba9e] px-7 py-3">Browse the collection</Link>
        <a href="mailto:asvasaclothing@gmail.com" className="border border-[#1A1A1A] text-[#1A1A1A] px-7 py-3">Write to the atelier</a>
      </div>
    </div>
  );
}
